const API = process.env.REACT_APP_BACKEND_URL;
const lum = (hex) => {
  const [r, g, b] = [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16) / 255);
  return 0.299 * r + 0.587 * g + 0.114 * b;
};
const rel = (hex) => {
  const [r, g, b] = [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16) / 255).map((c) => (c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4));
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};

export const brandAsset = (path) => (path ? `${API}${path}` : null);

export function brandVars(brand) {
  if (!brand) return {};
  const on = (c) => (1.05 / (rel(c) + 0.05) >= (rel(c) + 0.05) / 0.057 ? "#FFFFFF" : "#0B0F0B");
  const button = brand.button || brand.primary;
  const accent = [brand.primary, brand.secondary, button].find((c) => lum(c) > 0.35) || `color-mix(in srgb, ${brand.primary} 45%, #FFFFFF)`;
  const accentDay = brand.day_accent || [brand.primary, brand.secondary, button].filter((c) => c && rel(c) < 0.12).sort((a, b) => rel(b) - rel(a))[0] || `color-mix(in srgb, ${brand.primary} 62%, #080C0D)`;
  const pd = brand.palette?.day || {}, pn = brand.palette?.night || {};
  const btnDay = pd.button || button, btnNight = pn.button || button;
  return { "--brand-primary": brand.primary, "--brand-on-primary": on(brand.primary),
    "--brand-accent": pn.accent || accent, "--brand-button": btnNight, "--brand-on-button": pn.button_text || on(btnNight), "--brand-hero-text": pn.hero_text || undefined,
    "--brand-accent-day": pd.accent || accentDay, "--brand-button-day": btnDay, "--brand-on-button-day": pd.button_text || on(btnDay), "--brand-hero-text-day": pd.hero_text || undefined };
}

export function backdropStyle(brand) {
  if (!brand || brand.bg_mode === "none" || !brand.bg_mode) return null;
  const veil = "linear-gradient(180deg, rgba(5,7,13,0.45) 0%, rgba(5,7,13,0.78) 45%, rgba(5,7,13,0.92) 100%)";
  if (brand.bg_mode === "image" && brand.bg_url) return { backgroundImage: `${veil}, url(${brandAsset(brand.bg_url)})`, backgroundSize: "cover", backgroundPosition: "center" };
  return { backgroundImage: veil, backgroundColor: brand.bg_color };
}
